<quick-card
  [routerLink]="['./sessions']"
  [uid]="'sessions-card'"
  [heading]="'Sessions'"
  [loader]="loader"
  [headingIconKey]="'person_search'"
  [innerContentTemplate]="results"
  [matTooltip]="'Preview sessions registered in the RAG space'"
></quick-card>

<ng-template #results let-content=content>
  {{content['countTotal']}}
</ng-template>
